<template lang="pug">
div
  section.u-mt-md.u-mb-md
    .grid
      .column.is-desktop-5.is-widescreen-4
        ul.u-list-unstyled.u-active.u-sticky.legalNav
          li.h6.u-mb-xs: AppLink(to="/legal" class="button-link is-black is-small" :title="$t('legalHome')") {{ $t('legalHome') }}
          li.h6.u-mb-xs: AppLink(to="/legal/privacy-policy" class="button-link is-black is-small" :title="$t('privacyPolicy')") {{$t('privacyPolicy')}}
          li.h6.u-mb-xs: AppLink(to="/legal/terms-of-service" class="button-link is-black is-small" :title="$t('termsOfService')") {{$t('termsOfService')}}
          li.h6.u-mb-xs: AppLink(to="/legal/recruitment-privacy-policy" class="button-link is-black is-small" :title="$t('recruitmentPrivacyPolicy')") {{$t('recruitmentPrivacyPolicy')}}
          li.h6.u-mb-xs: AppLink(to="/legal/copyrights" class="button-link is-black is-small" :title="$t('copyrightsPolicy')") {{$t('copyrightsPolicy')}}
          li.h6.u-mb-xs: AppLink(to="/legal/dmca" class="button-link is-black is-small" :title="$t('dmca')")  {{$t('dmca')}}
          li.h6.u-mb-xs: AppLink(to="/legal/privacy-updates" class="button-link is-black is-small" :title="$t('privacyUpdates')") {{$t('privacyUpdates')}}

      .column.is-desktop-7.is-widescreen-5
        nuxt-child

</template>

<script>
export default {
  scrollToTop: true,

  head() {
    const $t = this.$t.bind(this);

    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  },
  meta: {
    logoText: 'legal'
  }
};
</script>

<style lang="stylus">
.legalNav
  top: 200px

  +mq($until: 'desktop')
    display: flex
    flex-wrap: wrap
    margin-bottom: unitRes(80, 200)

    li
      margin-right: unitRes(16, 32)

.legal-content
  p, a
    margin-bottom: unitRes(20, 40)

  h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6
    margin: unitRes(40, 80) 0 unitRes(20, 40)

  figure
    margin: unitRes(80, 100) unitRes(-80, -200)

    img
      max-width: 100%
      height: auto
</style>

<i18n>
{
  "en": {
    "pageTitle":"Legal",
    "legalHome": "Overview",
    "pageDesc":"Baianat privacy policy helps you understand everything related to the information collected and what we do with it.",
    "privacyPolicy":"Privacy policy",
    "termsOfService":"Terms of service",
    "webTerms":"Web terms and conditions",
    "recruitmentPrivacyPolicy":"Recruitment privacy policy",
    "copyrightsPolicy":"Copyrights policy",
    "dmca":"DMCA",
    "privacyUpdates":"Privacy updates"
  },
  "ar": {
    "pageTitle":"القوانين",
    "legalHome": "نظرة عامة ",
    "pageDesc":"تعرف على القوانين الخاصة ببيانات  التي تساعد على تقديم الخدمات بشكل  أفضل كشروط الخدمة وحقوق الألفية للملكية الرقمية.",
    "privacyPolicy":"سياسة الخصوصية",
    "termsOfService":"شروط الخدمة",
    "webTerms":"شروط وأحكام الموقع",
    "recruitmentPrivacyPolicy":"سياسة خصوصية التوظيف",
    "copyrightsPolicy":"سياسة حقوق التأليف والنشر",
    "dmca":"قانون الألفية للملكية الرقمية",
    "privacyUpdates":"تحديثات الخصوصية"
  }
}
</i18n>
